import axios, { AxiosError } from "axios";
import { toast } from "react-toastify";

interface ErrorResponseData {
  detail?: string;
  [key: string]: any;
}

export const mapAPIError = (error: unknown, code?: number): string => {
  const custom = "Something went wrong! Kindly try refreshing the page.";
  if (!axios.isAxiosError(error)) return custom;

  if (code === 500) {
    toast.error("Something went wrong! Kindly contact the admin.");
    return "Something went wrong! Kindly contact the admin.";
  }

  const errData = error?.response?.data as ErrorResponseData | string | undefined;

  if (typeof errData === "string") {
    if (code !== 401 && code !== 403) console.error(errData); // eslint-disable-line no-console
  } else if (errData && typeof errData === "object") {
    if (errData.detail) {
      if (code !== 401 && code !== 403) console.error(errData.detail); // eslint-disable-line no-console
    } else if (Object.keys(errData).length > 0) {
      const firstErrorKey = Object.keys(errData)[0];
      const firstErrorMsg = ` ${errData[firstErrorKey]}`;
      if (code !== 401 && code !== 403) console.error(firstErrorMsg); // eslint-disable-line no-console
    }
  }

  if (error.response) {
    const err = error.response.data;
    return err || custom;
  } else if (error.request) {
    return error.message || custom;
  } else {
    return error.message || custom;
  }
};
